import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { makeStyles } from "@mui/styles";

import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import { useTranslation } from "react-i18next";

const CeoMsg = () => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  return (
    <>
      <div className="css_team">
        <Container>
          <Box className={classes.product__inner}>
            <Box sx={{ textAlign: "center" }} className="title">
              {t("ceo_message")}
            </Box>

            <Grid
              container
              spacing={5}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "40px",
              }}
            >
              <Grid
                item
                md={4}
                sm={12}
                sx={{
                  display: "flex",
                  justifyContent: { sm: "center", md: "flex-start" },
                }}
              >
                <img src="img/ceo.png" alt="ceo" width="300" />
              </Grid>

              <Grid
                className={classes.box}
                item
                md={8}
                sm={12}
                sx={{ marginLeft: { sm: "35px", md: 0 }, pb: 4 }}
              >
                <ScrollAnimation animateIn="fadeIn" duration={2}>
                  <div
                    dangerouslySetInnerHTML={{ __html: t("ceo_message_exp") }}
                  ></div>
                </ScrollAnimation>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </div>
    </>
  );
};

export default CeoMsg;

const useStyles = makeStyles({
  product__inner: { paddingBottom: "100px", paddingTop: "100px" },
  card: {
    maxWidth: 275,
    paddingTop: "27px",
    paddingBottom: "25px",
    textAlign: "center",

    cursor: "pointer",
    "&:hover": {
      // color: "grey",
      boxShadow:
        "rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px",
    },
  },
  name: { fontWeight: "bold" },
  box: {
    width: "50%",
    color: "black",
    borderRadius: "20px",
    padding: "30px",
    backgroundColor: "white",
    position: "relative",
    top: "+20px",
    boxShadow:
      "rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
  },
});
